<template>
  <div>
    <div v-for="(manual, index) in ManualContainer" :key="index" class="manual">
      <h3>{{ manual.header }}</h3>
      <br />
    </div>
  </div>
</template>

<script>
export default {
  name: 'UseManual',
  data() {
    return {
      ManualContainer: [
        {
          header: this.$i18n.locale === 'eng' ? 'Create a peer evaluation' : '동료 평가 생성',
          paragrapth: '',
        },
        {
          header:
            this.$i18n.locale === 'eng'
              ? 'Peer Evaluation Results'
              : '동료 평가 결과동료 평가 결과',
          paragrapth: '',
        },
      ],
    };
  },
  watch: {
    '$i18n.locale': function (newLocale, oldLocale) {
      this.ManualContainer[0].header =
        newLocale === 'eng' ? 'Create a peer evaluation' : '동료 평가 생성';
      this.ManualContainer[1].header =
        newLocale === 'eng' ? 'Peer Evaluation Results' : '동료 평가 결과동료 평가 결과';
    },
  },
};
</script>

<style lang="scss"></style>
